import React, { Suspense, lazy } from "react";
import { useStore } from "../store/Store";
import { Card } from "react-bootstrap";
import { isMobileOnly } from "react-device-detect";
import prescriptionIcon from "src/assets/icons/Bottle.svg";
// import deleteIcon from "src/assets/icons/delete.svg";
// import { useQuery } from "react-query";
// import AddIcon from "src/assets/icons/plusWhite.svg";
// import { handleReset } from "../store/labTestFormReducer";
// import send from "src/assets/send.svg";
import save from "src/assets/icons/save.svg";
import savePink from "src/assets/save_pink.svg";
import plusPink from "src/assets/plus-pink.svg";
import useSearchQuery from "src/lib/useQuery";
import Loader from "src/components/Dashboard/common/Loader";

import { useStore as useStorePatient } from "../../../store/Store";
import { setUnsaved, setFunction, setsubFunction, setTabSwitched, } from "../../../store/PatientDetailsReducer";

import { addDiagnosisLabTestTemplate, addLabTest, } from "../api";
import { getQueryWithParams } from "src/components/ApolloConnection/ApolloProviderComponent";
import { LIST_DIAGNOSIS_TEMPLATES } from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";

const SavedLabTest = lazy(() => import("../savedDrug/SavedLabTest"));
const LabTestFormPopup = React.lazy(() => import("./LabTestFormPopup"));
const SavePrescriptionTemplate = React.lazy(() => import("../../prescription/SavePrescriptionTemplate"));

export async function listDiagnosisTemplates(search) {
  try {
    let response = await getQueryWithParams(LIST_DIAGNOSIS_TEMPLATES, { search }, true);
    if (
      response.errors == null &&
      response?.data != null &&
      response?.data?.listDiagnosisTemplates?.statusCode >= 200 &&
      response?.data?.listDiagnosisTemplates?.statusCode < 300
    ) {
      let data = response?.data?.listDiagnosisTemplates.data;
      let templates = [];
      data.map((template) => {
        templates.push({
          text: template.diagnosisName,
          value: template.diagnosisName,
        });
      });
      return templates;
    } else {
      throw new Error("not a valid response");
    }
  } catch (e) {
    snackbar({ message: "Error fetching Diagnosis lab templates.", color: "danger", });
    return [];
  }
}

const LabTestList = () => {
  const query = useSearchQuery();

  const { globalState, dispatch, dispatchForm } = useStore();
  const { globalState: globalStorePatient, dispatch: dispatchPatient } = useStorePatient();
  const [show, setShow] = React.useState(false);
  const [openPrescriptionTemplate, setOpenPrescriptionTemplate] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  let appointmentId = query.get("appointmentId");

  React.useEffect(() => {
    if (globalStorePatient.tabSwitched) {
      dispatchPatient(setFunction(handleSubmit));
      dispatchPatient(setTabSwitched(false));
    }
  }, [globalStorePatient.tabSwitched]);

  React.useEffect(() => {
    if (
      globalStorePatient.subActive == "labTest" &&
      globalStorePatient.tabSwitched
    ) {
      dispatchPatient(setsubFunction(handleSubmit));
      dispatchPatient(setTabSwitched(false));

      // dispatch(setTabSwitched(false));
    }
  }, [globalStorePatient.tabSwitched]);

  const openPopup = React.useCallback(() => { setShow(true); }, [setShow]);
  const closePopup = React.useCallback(() => { setShow(false); }, [setShow]);

  // const handleCancel = React.useCallback(() => {
  //   console.log("Reset");
  //   dispatch({ type: "RESET_PRESCRIPTION" });
  //   dispatchForm(handleReset());
  // }, [dispatch, dispatchForm]);

  const handleSubmit = React.useCallback(async () => {
    setLoading(true);

    const tests = globalState.labTests.map((test) => {
      return {
        testName: test.testName,
        instructions: test.instructions,
        optionalInstructions: (typeof test.optionalInstructions === 'number')
          ? test.optionalInstructions
          : 1
      }
    })

    const data = { appointmentId, tests };

    if (globalStorePatient.unsaved) {
      dispatchPatient(setUnsaved(false));
    }

    try {
      const res = await addLabTest(data);
      console.log("Submission successful:", res);
    } catch (error) {
      console.error("Submission failed:", error);
    } finally {
      setLoading(false);
    }

  }, [globalState]);

  const handlePrescriptionTemplateSubmit = React.useCallback(
    async (templateName, diagnosisTemplate) => {
      try {
        const tests = globalState?.labTests?.map((test) => {
          delete test.id;
          delete test.__typename;
          return test;
        });

        const data = { templateName, diagnosisTemplate, tests, };

        const response = await addDiagnosisLabTestTemplate(data);
        console.log("Submission successful:", response);
      } catch (error) {
        console.error("Error adding diagnosis lab test template:", error);
      }
    },
    [globalState]
  );

  return (
    <>
      {/* <Drug /> */}
      <Loader show={loading} />
      <Suspense fallback={<div>Loading...</div>}>
        <LabTestFormPopup show={show} closePopup={closePopup} />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <SavePrescriptionTemplate
          openPopup={openPrescriptionTemplate}
          closePopup={() => setOpenPrescriptionTemplate(false)}
          handleSubmit={handlePrescriptionTemplateSubmit}
          title="Template Name"
        />
      </Suspense>
      {
        <Card className="docg-patient-form-wrapper h-100">
          <Card.Title className="justify-content-between">
            <div className="d-flex align-items-center">
              {!isMobileOnly && (
                <>
                  <img className="mr-2" src={prescriptionIcon} alt="" />
                  {globalState?.labTests?.length > 0
                    ? "Lab Tests"
                    : "No Lab Tests"}
                </>
              )}
            </div>
            {isMobileOnly ? (
              <div className="d-flex">
                {globalState?.labTests?.length > 0 ? (
                  <>
                    <button
                      type="button"
                      onClick={() => setOpenPrescriptionTemplate(true)}
                      className={"docg-pink-btn ml-2"}
                    >
                      <img src={savePink} alt="" />
                      Template
                    </button>
                    <button
                      onClick={handleSubmit}
                      className={"docg-pink-btn ml-2"}
                    >
                      <img src={savePink} alt="" />
                      Save Tests
                    </button>
                    <button
                      onClick={openPopup}
                      className="docg-pink-btn ml-2"
                      type="button"
                    >
                      <img src={plusPink} alt="" /> Add Test
                    </button>
                  </>
                ) : (
                  <button
                    onClick={openPopup}
                    className="docg-pink-btn ml-2"
                    type="button"
                  >
                    <img src={plusPink} alt="" /> Add Test
                  </button>
                )}
              </div>
            ) : (
              <div className="d-flex">
                {globalState?.labTests?.length > 0 ? (
                  <>
                    <button
                      type="button"
                      onClick={() => setOpenPrescriptionTemplate(true)}
                      className="docg-save-btn bg-purple ml-2"
                    >
                      <img src={save} alt="" />
                      Template
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="docg-save-btn ml-2"
                    >
                      <img src={save} alt="" /> Save Tests
                    </button>
                    <button
                      onClick={openPopup}
                      className="docg-pink-btn ml-2"
                      type="button"
                    >
                      <img src={plusPink} alt="" /> Add Test
                    </button>
                  </>
                ) : (
                  <button
                    onClick={openPopup}
                    className="docg-pink-btn ml-2"
                    type="button"
                  >
                    <img src={plusPink} alt="" /> Add Test
                  </button>
                )}
              </div>
            )}
          </Card.Title>
          {globalState.labTests.length > 0 ? (
            <Card.Body>
              {globalState.labTests.map((labTest) => (
                <Suspense fallback={<div>Loading...</div>}>
                  <SavedLabTest key={labTest.id} labTest={labTest} />
                </Suspense>
              ))}
            </Card.Body>
          ) : (
            <>
              <div className="d-flex align-items-center justify-content-center w-100 h-100 p-2">
                <button
                  onClick={openPopup}
                  className="docg-pink-btn ml-2"
                  type="button"
                >
                  <img src={plusPink} alt="" /> Add Test
                </button>
              </div>
            </>
          )}
        </Card>
      }
    </>
  );
};

export default LabTestList;
